module.exports = __webpack_public_path__ + "assets/img/camera.70450046.png";